import { SubmitButtonProps } from 'components/common/submitButton'
import React from 'react'
import { Form } from 'react-final-form'
import { Trans, useTranslation } from 'react-i18next'
import CodeField from '../components/codeField'
import { useFormsStyles } from '../forms.css'

interface Props {
    subscription?: { [property: string]: boolean }
    onSubmit: (values: EmailValidationFormState) => void
    resendButton: (props: Partial<SubmitButtonProps>) => React.ReactNode
    children: (content: React.ReactNode, actions: Array<SubmitButtonProps>) => React.ReactNode
    formClassName?: string
    inProgress: boolean
    initialValues: EmailValidationFormState
}

export interface EmailValidationFormState {
    code: string
}

interface EmailValidationFormErrors {
    code?: string
}

const EmailValidationForm: React.FC<Props> = ({
    subscription = {
        submitting: true,
        pristine: true,
    },
    onSubmit,
    children,
    formClassName,
    inProgress,
    initialValues,
    resendButton,
}) => {
    const formsClasses = useFormsStyles()
    const { t } = useTranslation()

    const validate = (values: EmailValidationFormState) => {
        const errors: EmailValidationFormErrors = {}

        if (!values.code) {
            errors.code = t('form-validation.code')
        } else if (values.code.length !== 6) {
            errors.code = t('form-validation.codeLength')
        }

        return errors
    }

    return (
        <Form
            initialValues={initialValues}
            subscription={subscription}
            // debug={console.log}
            onSubmit={onSubmit}
            validate={validate}
            keepDirtyOnReinitialize
        >
            {({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit} noValidate className={formClassName}>
                    {children(
                        <>
                            <CodeField
                                name="code"
                                onChange={(value) => {
                                    if (value.length === 6) {
                                        handleSubmit()
                                    }
                                }}
                            />
                            <div>{resendButton({})}</div>
                        </>,
                        [
                            {
                                type: 'submit',
                                loading: submitting || inProgress,
                                className: formsClasses.submit,
                                children: <Trans i18nKey="actions.continue" />,
                            },
                        ],
                    )}
                </form>
            )}
        </Form>
    )
}

export default EmailValidationForm
